import axios from './axios';

export const getRamsDashboard = () => axios.get('rams/dashboard');
export const getRamsActive = (params = {}) => axios.get('rams/active', { params });
export const getRamsProjects = () => axios.get('rams/projects');
export const getRamsProjectsList = () => axios.get('rams/projects-list');
export const getRamsProjectDetail = (id) => axios.get(`rams/projects/${id}`);
export const getRamsSettings = () => axios.get('rams/settings');

export const getRamsDocuments = (params = {}) => axios.get('rams/documents', { params });
export const createRamsDocument = (formData) => axios.post('rams/documents', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const updateRamsDocument = (id, formData) => axios.post(`rams/documents/${id}`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const deleteRamsDocument = (id) => axios.delete(`rams/documents/${id}`);
export const toggleRamsDocumentActive = (id) => axios.patch(`rams/documents/${id}/toggle-active`);
export const getRamsDocumentVersions = (id) => axios.get(`rams/documents/${id}/versions`);

export const getRamsDocumentPdfInfo = (id) => axios.get(`rams/documents/${id}/pdf-info`);
export const getRamsDocumentPdfUrl = (id) => axios.get(`rams/documents/${id}/pdf-url`);
export const getRamsDocumentPdfContent = (id) => axios.get(`rams/documents/${id}/pdf-content`, { responseType: 'arraybuffer' });
export const saveRamsPlaceholderConfig = (id, config) => axios.put(`rams/documents/${id}/placeholder-config`, { placeholder_config: config });
export const previewRamsPlaceholders = (id) => axios.get(`rams/documents/${id}/preview-placeholders`, { responseType: 'blob' });

export const getRamsProjectSubcontractors = (projectId) => axios.get(`rams/projects/${projectId}/subcontractors`);
export const createRamsRun = (data) => axios.post('rams/runs', data);
export const getRamsSignedRecords = (ramsRecordId) => axios.get(`rams/records/${ramsRecordId}/signed`);
export const downloadRamsSignedPdf = (ramsSignedId) => axios.get(`rams/signed/${ramsSignedId}/download`);
export const getProjectRamsReport = (projectId) => axios.get(`rams/projects/${projectId}/report`);
export const downloadRamsSignOffSheet = (ramsRecordId) => axios.get(`rams_records/${ramsRecordId}/signoff-sheet`);
export const downloadRamsFullWithSignOff = (ramsRecordId) => axios.get(`rams_records/${ramsRecordId}/full-with-signoff`, { responseType: 'blob' });

export const downloadRamsRevisionSheet = (ramsRecordId) => axios.get(`rams_records/${ramsRecordId}/revisions-pdf`, { responseType: 'blob' });

export const getRamsRevisions = (ramsRecordId) => axios.get(`rams_records/${ramsRecordId}/revisions`);

export const getRamsListItems = () => axios.get('rams/list-items');

export const getHsUsers = () => axios.get('rams/hs-users');

export const getRamsDocumentOrder = () => axios.get('rams/document-order');
export const saveRamsDocumentOrder = (orders) => axios.put('rams/document-order', { orders });
